import {
    FETCH_RESERVATIONS,
    FETCH_RESERVATIONS_FAILURE,
    FETCH_RESERVATIONS_SUCCESS,

    FETCH_RESERVATION,
    FETCH_RESERVATION_FAILURE,
    FETCH_RESERVATION_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';

// Fetch Points of interest
export const fetchReservations = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 12,
        sort_by: payload.field ? payload.field : 'id',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'asc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_RESERVATIONS,
        payload: params,
    };
};

export const fetchReservationsFailure = (error) => {
    return {
        type: FETCH_RESERVATIONS_FAILURE,
        error: error,
    };
};

export const fetchReservationsSuccess = (payload) => {
    return {
        type: FETCH_RESERVATIONS_SUCCESS,
        payload: payload,
    };
};

// Fetch Point of interest
export const fetchReservation = (payload) => {
    return {
        type: FETCH_RESERVATION,
        payload: payload,
    };
};

export const fetchReservationFailure = (error) => {
    return {
        type: FETCH_RESERVATION_FAILURE,
        error: error,
    };
};

export const fetchReservationSuccess = (response) => {
    return {
        type: FETCH_RESERVATION_SUCCESS,
        response: response,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/reservations/fetchReservations.js